/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [
    {
      mode: 'modal',
      icon: 'phone',
      text: 'Contact Us',
      color: '#5c6c7d',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      font: {
        family: 'AUTO',
      },
      devices: ['desktop', 'laptop'],
    },
    {
      mode: 'modal',
      icon: 'phone',
      color: '#5c6c7d',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['tablet', 'mobile'],
    },
  ],
  modal_options: {
    header_text:
      '<img style="margin-top:10px;max-width:200px;" src="https://cdn.shopify.com/s/files/1/0580/5552/4491/files/Logo_2000x.png?v=1656692935">',
    header_color: '#5c6c7d',
    description_text:
      'Ready for window treatments?<br/>Schedule your consultation today!',
    buttons: [
      {
        title: '(714) 386-6526',
        link: 'tel:+17143866526',
        txt_color_hover: '#AB8B6A',
        bg_color: '#AB8B6A',
        class_list: ['call-us'],
        icon: 'phone',
      },
      {
        title: 'VISIT SHOWROOM',
        link: 'https://www.google.com/maps/place/Blinds+Plus+Designs/@33.6718018,-117.9991115,17z/data=!4m13!1m7!3m6!1s0x80dd214a2099ab8d:0xbaff3fb2efbc5d96!2s1619+Alabama+St,+Huntington+Beach,+CA+92648,+USA!3b1!8m2!3d33.6718018!4d-117.9969228!3m4!1s0x80dd25c92e1e33e3:0xe5e827494158bdb9!8m2!3d33.6718018!4d-117.9969228',
        link_target: '_blank',
        txt_color_hover: '#AB8B6A',
        bg_color: '#AB8B6A',
        class_list: ['visit-showroom'],
        icon: 'map-pin',
      },
      {
        title: 'CONTACT US',
        link: '/pages/contact',
        bg_color: '#AB8B6A',
        txt_color_hover: '#AB8B6A',
        class_list: ['contact-us'],
        icon: 'email',
      },
    ],
    footer_text:
      'Let Blinds Plus Designs help you design your dream home with custom window treatments, home decor, and more. Visit our casual coastal studio today. Can’t visit us? We’ll come to you! Schedule your personal consultation today.',
    footer_color: '#5c6c7d',
  },
}).then((_) => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us',
      action: 'Call (714) 386-6526 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .visit-showroom',
      action: 'Visit Showroom - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .contact-us',
      action: 'Contact Us - ConvertBoost©',
      event: 'click',
    },
  ]);
});
